import { gql } from '@apollo/client';
import { ITEM_FIELDS } from '../../fragments';
import { CreateItemProps, RemoveItemProps, UpdateItemProps } from './item.types';
import { InvoiceItemType } from '../../../types';
import { GET_INVOICE_BY_INVOICE_ID } from '../../queries';

export const CREATE_ITEM = gql`
  ${ITEM_FIELDS}
  mutation createItem(
  $invoiceId: ID!
  $name: String!
  $description: String!
  $unit: String!
  $unitPrice: Float!
  $quantity: Float!
  ) {
    createItem(
    invoiceId: $invoiceId
    name: $name
    description: $description
    unit: $unit
    unitPrice: $unitPrice
    quantity: $quantity
    ) {
      ...ItemFields
    }
  }
`;

export function createItem({
  client,
  invoiceId,
  name,
  description,
  unit,
  unitPrice,
  quantity,
}: CreateItemProps) {
  return client?.mutate<{ createItem: InvoiceItemType }>({
    mutation: CREATE_ITEM,
    variables: {
      invoiceId,
      name,
      description,
      unit,
      unitPrice,
      quantity,
    },
    refetchQueries: [
      GET_INVOICE_BY_INVOICE_ID,
    ],
  });
}

export const UPDATE_ITEM = gql`
  ${ITEM_FIELDS}
  mutation updateItem(
  $invoiceId: ID!
  $name: String!
  $description: String!
  $unit: String!
  $unitPrice: Float!
  $quantity: Float!
  ) {
    updateItem(
    invoiceId: $invoiceId
    name: $name
    description: $description
    unit: $unit
    unitPrice: $unitPrice
    quantity: $quantity
    ) {
      ...ItemFields
    }
  }
`;

export function updateItem({
  client,
  itemId,
  name,
  description,
  unit,
  unitPrice,
  quantity,
}: UpdateItemProps) {
  return client?.mutate<{ updateItem: InvoiceItemType }>({
    mutation: UPDATE_ITEM,
    variables: {
      itemId,
      name,
      description,
      unit,
      unitPrice,
      quantity,
    },
    refetchQueries: [
      GET_INVOICE_BY_INVOICE_ID,
    ],
  });
}

export const REMOVE_ITEM = gql`
  mutation removeItem(
  $itemId: ID!
  ) {
    removeItem(
    itemId: $itemId
    )
  }
`;

export function removeItem({
  client,
  itemId,
}: RemoveItemProps) {
  return client?.mutate<{ removeItem: InvoiceItemType }>({
    mutation: REMOVE_ITEM,
    variables: {
      itemId,
    },
    refetchQueries: [
      GET_INVOICE_BY_INVOICE_ID,
    ],
  });
}
